let init = {
    diamondList: {
        diamondListTable: [],
        limit: 5,
        page: 0,
        totalDocs: 0,
        totalPages: 0
    },
};

const diamondPackReducer = (state = init, { type, payload }) => {
    switch (type) {
        case 'GET_DIAMOND_PACK_LIST': {
            return {
                ...state,
                diamondList: {
                    diamondListTable: payload?.docs,
                    totalDocs: payload?.totalDocs,
                    totalPages: payload?.totalPages,
                    limit: payload?.limit,
                    page: payload?.page - 1
                }
            };
        }
        case 'ADD_DIAMOND_PACK_LIST': {
            return {
                ...state,
                diamondList: {
                    ...state.diamondList,
                    diamondListTable: [payload, ...state.diamondList.diamondListTable],
                    totalDocs: Number(state.diamondList?.totalDocs) + 1,
                }
            };
        }
        case 'UPDATE_DIAMOND_PACK_LIST': {
            let temp = { ...state };
            let index = temp.diamondList.diamondListTable.findIndex((item) => item._id === payload._id);
            if (index > -1) {
                temp.diamondList.diamondListTable[index] = payload;
            }
            return temp;
        }
        case 'DELETE_DIAMOND_PACK': {
            let filters = state.diamondList.diamondListTable.filter(item => item._id !== payload.diamondPackageId);
            return {
                ...state,
                diamondList: {
                    ...state.diamondList,
                    diamondListTable: filters,
                    totalDocs: Number(state.diamondList?.totalDocs) - 1,
                }
            };
        }

        default: {
            return state;
        }
    }
};

export default diamondPackReducer;
